import { queryOptions, useQuery } from '@tanstack/react-query';

import { giftCardsApi } from '../api/gift-cards-api';

import { giftCardKeys } from './gift-card-keys';

/** The ledger, newest first: issue, redemptions, refunds and adjustments. */
export function giftCardTransactionsQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: giftCardKeys.transactions(storeId, id),
    queryFn: () => giftCardsApi.transactions(storeId, id),
  });
}

export function useGiftCardTransactions(storeId: string, id: string) {
  return useQuery(giftCardTransactionsQueryOptions(storeId, id));
}
